import { CONTACT_EMAIL } from "@/lib/assets";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="heading text-2xl text-[#67e8f9] mb-3">{title}</h2>
    <div className="font-rajdhani text-gray-300 text-base leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Termini() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-16" data-testid="termini-page">
      <p className="font-rajdhani uppercase tracking-widest text-xs text-gray-500 mb-2">Legale</p>
      <h1 className="heading text-4xl sm:text-5xl text-white mb-2">Regolamento & <span className="text-[#67e8f9]">Termini dei Tornei</span></h1>
      <p className="font-rajdhani text-gray-500 text-sm mb-10">Ultimo aggiornamento: agosto 2026</p>

      <Section title="1. Accettazione">
        <p>Partecipando ai tornei di <strong>Seals / Seals Allies Force</strong> ogni giocatore e caposquadra
        dichiara di aver letto e accettato integralmente il presente regolamento.</p>
      </Section>

      <Section title="2. Iscrizione e squadre">
        <ul className="list-disc pl-5 space-y-1">
          <li>L'iscrizione avviene esclusivamente tramite il bot Discord ufficiale o, in casi eccezionali, tramite lo staff.</li>
          <li>Ogni squadra deve rispettare il numero di giocatori previsto dal torneo (duo, trio o quad).</li>
          <li>I dati forniti (nome utente Discord, Activision ID ed eventuale K/D) devono essere veritieri.</li>
            <li>Quando il torneo prevede K/D VERIFIED, il caposquadra inserisce manualmente i valori richiesti e fornisce gli screenshot di prova anche per i compagni; il dato diventa verificato solo dopo il controllo dello staff.</li>
            <li>Un K/D VERIFIED valido può essere riutilizzato per la stessa modalità fino alla relativa scadenza; alla scadenza è richiesta una nuova verifica.</li>
          <li>Il caposquadra è il responsabile della squadra e l'unico autorizzato a inviare i risultati.</li>
        </ul>
      </Section>

      <Section title="3. Svolgimento e lobby">
        <ul className="list-disc pl-5 space-y-1">
          <li>L'assegnazione delle lobby è gestita dallo staff; le squadre riceveranno lobby e codice tramite Discord.</li>
          <li>Il codice lobby è riservato: la condivisione con esterni comporta la squalifica.</li>
        </ul>
      </Section>

      <Section title="4. Risultati e prove">
        <ul className="list-disc pl-5 space-y-1">
          <li>Ogni caposquadra deve inviare i risultati (kill individuali e piazzamento) al termine della partita.</li>
          <li>È obbligatorio allegare gli screenshot di prova richiesti.</li>
            <li>Le prove screenshot sono evidenze temporanee utilizzate durante il lifecycle operativo del torneo e possono essere eliminate dopo l'archiviazione, mentre i dati strutturati necessari allo storico vengono conservati.</li>
          <li>Lo staff verifica e approva i risultati; risultati falsi o alterati comportano penalità o squalifica.</li>
        </ul>
      </Section>

      <Section title="5. Punteggi e adjustment amministrativi">
        <p>Il punteggio squadra deriva da piazzamento e uccisioni secondo le regole del singolo torneo. Lo staff
        può applicare adjustment amministrativi positivi o negativi al punteggio di squadra, con relativa motivazione;
        tali variazioni non alterano le statistiche individuali dei giocatori (MVP).</p>
      </Section>

      <Section title="6. Condotta">
        <p>Sono vietati cheat, exploit, bug abusing, teaming non consentito, comportamenti offensivi o
        antisportivi. Lo staff si riserva la facoltà di escludere chiunque violi queste regole, a proprio insindacabile giudizio.</p>
      </Section>

      <Section title="7. Modifiche al regolamento">
        <p>Lo staff può aggiornare il presente regolamento in qualsiasi momento. Le modifiche saranno pubblicate
        su questa pagina. Per chiarimenti: <a className="text-[#67e8f9] underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
      </Section>
    </div>
  );
}
